import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core'
import { BadgeStatusComponent } from '@components/badge-status/badge-status.component'

@Component({
  selector: 'app-color',
  standalone: true,
  imports: [CommonModule, TranslateModule, BadgeStatusComponent],
  templateUrl: './color.component.html',
  styleUrl: './color.component.scss'
})
export class ColorComponent {
  @Input() mainImage: string = '';
  @Input() name: string = '';
  @Input() brand: string = '';
  @Input() colorCode: string = '';
  @Input() isSelected: boolean = false;
  @Input() discount: string = '';
  @Input() isNew: boolean = false;

  @Output() colorSelected = new EventEmitter<any>();

  onSelect(): void {
    this.colorSelected.emit({
      name: this.name,
      brand: this.brand,
      colorCode: this.colorCode,
      image: this.mainImage
    });
  }
}
